export default {
  newDesign: true,
  parameters: {
    landing_id: "UAEFreeTC",
    segment: 3,
    date_start: 0,
    date_end: 6,
  },
  title:
    "Programming courses for children aged 8-17 at an international school | Kodland",
  downtimeUrl: "https://www.kodland.org/",
  startPage: {
    title: "Answer the questions to sign up for your first trial lesson.",
    subtitle:
      "We’ll show how to turn a passion for gadgets into an advantage:<br>💬 Discover your child's talents in a fun way<br>🌐 All you need is a computer and an internet connection<br>💙 Trusted by over 100,000 parents",
    image: {
      url: "/welcome/uae_freeclass_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/uae_freeclass_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Let's go! 🔥",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Thank you for trusting our educational platform!",
    subtitle:
      "Unfortunately, tablets or phones are not suitable for taking our lessons. We’ll be happy to see you in our classes next time!",
  },
  customStopPages: {
    minAge: {
      title: "Thank you for trusting our educational platform!",
      subtitle: "We’re sorry for the inconvenience, but Kodland classes are designed for children aged 8 to 17. We hope to see you again in the future! 😊",
      image: "/welcome/quizV2/ageENGV2.png",
    },
    maxAge: {
      title: "Thank you for trusting our educational platform!",
      subtitle: "We’re sorry for the inconvenience, but Kodland classes are designed for children aged 8 to 17. We hope to see you again in the future! 😊",
      image: "/welcome/quizV2/ageENGV2.png",
    },
  },
  quizRotateBySteps: {
    1: {
      title: "How old is your child?",
      type: "age",
      button: "",
    },
    2: {
      question: "What does your child like to do in their free time?",
      answers: [
        "Play sports or outdoor games ⚽",
        "Read books or comics 📚",
        "Watch TV, YouTube, or play video games 🎮",
        "Spend time with friends or family 👫",
        "Other 🙂",
      ],
    },
    3: {
      question: "How does your child feel about learning online?",
      answers: [
        "They love it and find it engaging 💻❤️",
        "They’re okay with it but prefer in-person learning 🙂",
        "They find it challenging to stay focused 😵‍💫",
        "They’ve never tried learning online ❓",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/uae_recommended_hours.png",
      subtitle:
        "While it is recommended that children limit their screen time to no more than 2 hours per day, many often exceed this amount. To support a healthy balance, we suggest combining entertainment with productive activities, such as lessons lasting 1 to 1.5 hours.<br>Our programs are thoughtfully designed to encourage this balance.",
      button: "A great choice!",
    },
    5: {
      question: "In school, what does your child enjoy the most?",
      answers: [
        "Science experiments or math challenges 🧪🔢",
        "Reading and writing stories 📚✍️",
        "Art, music, or creative activities 🎨🎶",
        "Physical education or sports 🏃‍♀️🏋️‍♂️",
        "Other 🙂",
      ],
    },
    6: {
      question:
        "Does your child enjoy building or designing things (e.g., with Lego, art, puzzles)?",
      answers: [
        "Yes, they love building and designing things 🧩🏗️",
        "Sometimes, but they prefer other activities 🤔",
        "No, they’re not very interested in those 🙅‍♂️",
      ],
    },
    7: {
      question: "How does your child best remember or learn new things?",
      answers: [
        "By seeing (visual learner) 👁️",
        "By doing (hands-on learner) 👐",
        "By listening (auditory learner) 🎧",
        "Through repetition and practice 🔄✏️",
      ],
    },
    8: {
      question:
        "Does your child have access to a laptop or desktop PC for studying?",
      answers: [
        "Yes, they have their own device 💻✅",
        "Yes, but they share it with others 🖥️👫",
        {
          answer: "No, they don’t have regular access 🚫",
          stopAnswer: true,
        },
      ],
    },
    9: {
      question:
        "What kind of activities or hobbies attract your child the most?",
      answers: [
        "Moving around (sports, dance) ⚽💃",
        "Getting creative (drawing, crafts) 🎨🖌️",
        "Using my brain (puzzles, coding) 🧩💻",
        "Chilling out (games, videos) 🎮📺",
        "Something else 🙂",
      ],
    },
    10: {
      question: "How does your child act when working with others in a group?",
      answers: [
        "They enjoy collaborating and sharing ideas 🤝💡",
        "They prefer to lead and take charge 🧑‍⚖️",
        "Likes to work solo, but helps when needed 👤✔️",
        "They feel shy or uncomfortable in group settings 😳",
      ],
    },
    11: {
      question: "What role does your child usually take in group activities?",
      answers: [
        "They like to lead and organize 🧑‍⚖️🗂️",
        "They enjoy contributing ideas and collaborating 🤝💡",
        "They prefer to listen and follow 👂🙂",
        "They try to mediate or solve conflicts ⚖️🕊️",
        "They feel shy and stay in the background 😳",
      ],
    },
    12: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle:
        "We offer both individual and group learning formats, and we take into account the children's age to tailor the process to each child as much as possible.",
      button: "Let's go!",
    },

    13: {
      question: "Has your child shown interest in learning to code or program?",
      answers: [
        "Yes, they’ve already started learning 💻🚀",
        "Yes, they’re curious but haven’t tried yet 🤔💡",
        "Not yet, but they might be interested 🤷‍♂️",
        "No, they’re not interested 🙅‍♀️",
      ],
    },
    14: {
      question: "What is your child's gender?",
      answers: ["Male 👦", "Female 👧", "I'd rather not say 🤐"],
    },
    15: {
      question: "What activities or subjects does your child enjoy the most?",
      answers: [
        "Reading or writing 📚✍️",
        "Art, music, or theater 🎨🎶🎭",
        "Sports or physical activities 🏃‍♀️⚽",
        "Technology or computers 💻📱",
        "Other 🙂",
      ],
    },
    16: {
      question:
        "Does your child enjoy creating things or doing activities with friends?",
      answers: [
        "Yes, they love group creative projects 👫🎨",
        "Sometimes, depending on the activity 🤔",
        "No, they prefer individual tasks 👤💡",
      ],
    },
    17: {
      question:
        "Is your child comfortable using technology, like computers, apps, or basic internet tasks?",
      answers: [
        "Yes, they’re very comfortable and use it often 💻✔️",
        "Can handle simple stuff, but needs help with tricky tasks 🖱️❓",
        "No, they’re not very familiar with technology 🚫",
      ],
    },
    18: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/uae_create.png",
      subtitle:
        "At Kodland, students design 3D models, create comics, build games, and develop computer programs. Currently, 30,000 children worldwide are learning with us!",
      button: "Great!",
    },
    19: {
      question: "How does your child deal with challenges or problems?",
      answers: [
        "They try to solve them independently 💪🧠",
        "They ask for help when needed 🙋‍♀️✔️",
        "They can get frustrated and give up easily 😤",
        "They enjoy problem-solving and see it as a challenge 🕵️‍♂️",
      ],
    },
    20: {
      question:
        "Does your child show interest in creating their own stories or characters?",
      answers: [
        "Yes, they love storytelling and have lots of ideas ✍️🌟",
        "Sometimes, but they need encouragement 🤗",
        "No, they’re not very interested in that 🚫",
      ],
    },
    21: {
      question:
        "How does your child handle tasks that require attention and logical thinking?",
      answers: [
        "They’re good at focusing and solving problems 🎯🧩",
        "They do well with some guidance or structure 🗂️🤝",
        "They struggle to focus on detailed tasks 😵‍💫",
      ],
    },
    22: {
      question: "When your child tells a story, do they tend to...",
      answers: [
        "Focus on lots of details and descriptions 📝📜",
        "Get straight to the main point 🎯",
        "Add humor or imagination to their story 🤪✨",
        "Struggle to organize their thoughts 🤔",
      ],
    },
    23: {
      question: "How does your child usually react when trying something new?",
      answers: [
        "They dive in with excitement 🎉🚀",
        "They stay curious but cautious 🤔👣",
        "They feel nervous and need encouragement 😬🤗",
        "They love experimenting on their own 🛠️🔬",
        "They resist trying new things 🙅‍♂️",
      ],
    },
    24: {
      question:
        "Does your child prefer to follow instructions or come up with their own ideas?",
      answers: [
        "They love clear instructions and completing tasks 📋✔️",
        "They prefer creative ideas and new approaches 🎨💡",
        "They like a mix of structure and freedom ⚖️🛠️",
        "Depends on the task – some like rules, others like freedom 🤷‍♂️",
      ],
    },
    25: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/uae_reviews.png",
      subtitle:
        "We are recommended by parents all over the world. We hope you’ll join them soon 💙",
      button: "We're almost done",
    },
    26: {
      question: "What motivates your child to stay focused on a task?",
      answers: [
        "A clear goal or reward at the end 🎯🏅",
        "Excitement or passion for the task ✨❤️",
        "Working on it with others as part of a group 🤝💬",
        "Needs encouragement & good vibes 👏😊",
        "A sense of competition or challenge 🥇🔥",
      ],
    },
    27: {
      question:
        "What kind of stories or topics does your child enjoy talking about?",
      answers: [
        "Adventures, mysteries, or fantasy 🗺️🐉",
        "Science, technology, or inventions 🔬💻",
        "Funny or silly stories 🤪😂",
        "Real-life events or history 📜🌍",
        "Stories about friendships or emotions ❤️👫",
      ],
    },
    28: {
      question: "What makes your child feel proud or accomplished?",
      answers: [
        "Completing a challenging task 🏆🧠",
        "Helping others or contributing 🤝❤️",
        "Learning something new 📚✨",
        "Getting positive feedback 🥳👏",
        "Solving a tricky problem 🔍🧩",
      ],
    },
    29: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/uae_signup.png",
      title: "Just one step left 🎉 ",
      subtitle:
        "Unlock your child's creative potential in coding and digital creation!",
      button: " 📅 Schedule a lesson",
    },
    30: {
      title: "Sign up for a free trial class",
      type: "one-page-contacts",
      subtitle:
        "Let’s get to know each other, find out what we will learn, and how the lessons will be conducted.",
      button: "Almost done 🔥",
    },
    31: {
      typeInfo: "noQuestions",
      title: "Check out this information to complete the registration ✨",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It’s also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "Ok",
    },
    32: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    33: {
      title: "Thank you! Your free trial class has been successfully booked 🎉",
      typeInfo: "pc-laptop",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It's also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "What else?",
    },
    34: {
      title: "Before the trial, check your email and WhatsApp for updates 📞",
      typeInfo: "whatsapp",
      subtitle:
        "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
      button: "Great!",
    },
    35: {
      title: "The lesson will take place on our platform 💻",
      typeInfo: "classroom",
      subtitle:
        "You'll get a link and a unique code via WhatsApp and email. Just click the link, it will take you straight to the lesson. No extra apps, no downloads.",
      button: "Got it ✅",
    },
  },
};
